import { Ability } from "@casl/ability";
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

var user = JSON.parse(sessionStorage.getItem("user"));
let rules = [];
if (user && user.role && user.role.permissions) {
  user.role.permissions.forEach((permission) => {
    let rule = {
      action: permission._action ? permission._action : "",
      subject: permission._entity ? permission._entity.capitalize() : "",
    };
    rules.push(rule);
  });
}

export default new Ability(rules);
